export default __webpack_public_path__ + "static/media/T_CarpetTile.ada3a863.jpg";